import {submitEventMerge, submitMerge} from "@otto-ec/tracking-bct";
import {promoComboPresentation} from "@otto-ec/nexus-registry/promo/combo/presentation";

export default class ComboPromoButton {

  constructor() {
    this.articleNumber = null;
    this.imageIdToCombo = null;
    this.destinationDomElement = null;
    this.promoComboPresentation = null;

    this.initialize();
  }

  initialize() {
    this.promoComboPresentation = promoComboPresentation;
    promoComboPresentation.variationChange.on((data) => {
      this.loadButton(
        data.articleNumber,
        data.targetElement,
        data.imageId,
        data.imagePreset,
        data.eventMergeId,
        data.variationId,
      );
    });
    promoComboPresentation.imageChange.on((data) => this.update(data.imageId));
    window.otto.ft3bcn.combopromo.updateButton.on((data) => {
      if (data.json) this.updateButton(data.json, data.eventMergeId, data.imageId);
    })
  }

  async loadButton(articleNumber, destinationDomElement, imageId, _preset, eventMergeId, variationId) {
    this.variationId = variationId;
    this.articleNumber = articleNumber;
    this.destinationDomElement = destinationDomElement;

    if (imageId && typeof imageId !== "string") throw new Error("imageId has to be a string");

    const STATUS_CODE_OK = 200;
    let url = `/combo-combopromo/button/${articleNumber}`;
    if (imageId) url += `?imageId=${encodeURIComponent(imageId)}`;

    if (articleNumber) {
      try {
        await fetch(url, {
          method: "GET",
          headers: {
            "accept": "application/json"
          }
        }).then(async (response) => {
          if (response.status === STATUS_CODE_OK) {
            try {
              await response.json().then((json) =>
                window.otto.ft3bcn.combopromo.updateButton.emit({
                  json: json,
                  eventMergeId: eventMergeId,
                  imageId: imageId
                }));
            } catch (exception) {
              if (exception instanceof TypeError || exception.name === 'AbortError') throw exception
              throw new Error(`Output cannot be parsed: url ${url} Status code: ${response.status} 
                               And response: ${await response.text()}.With exception: ${exception}`);
            }
          }
          this.handlePromoButtonHypotheticalTrackingLoadEvent(response.headers, eventMergeId)
        })
      } catch (exception) {
        if (!(exception instanceof TypeError || exception.name === 'AbortError')) {
          throw new Error(`Failed to fetch url ${url} : ${exception.name} : ${exception.message}`);
        }
      }
    }
  }

  handlePromoButtonHypotheticalTrackingLoadEvent(headers, eventMergeId){
    const daliAvailabilityHeader = headers.get("daliComboAvailability")

    if(daliAvailabilityHeader){
      window.o_p13n_combopromo.tracking.sendPromoButtonHypotheticalTrackingLoadEvent(daliAvailabilityHeader.toString(), eventMergeId);
    }
  }

  updateButton(json, eventMergeId, imageId) {
    this.imageIdToCombo = json.imageIdToCombo;
    this.comboType = json.comboType || "OUTFIT";
    this.title = json.title;
    this.cssComboTypeImageClass = json.cssComboTypeImageClass;
    this.cssFormatImageClass = json.cssFormatImageClass;
    this.cssFormatButtonClass = json.cssFormatButtonClass;
    this.toggles = json.toggles || {};
    this.daliComboAvailability = json.daliComboAvailability;

    let usedImageId = this.imageExists(imageId) ? imageId : json.newestComboImageId;

    if (this.imageExists(usedImageId)) {
      this.injectButtonHtml(usedImageId);
      let comboId = this.imageIdToCombo[usedImageId].comboId;
      let source = this.imageIdToCombo[usedImageId].source;

      if (eventMergeId) {
        submitEventMerge(eventMergeId, this.buildInitialViewTracking());
        window.o_p13n_combopromo.tracking.sendPromoButtonMergePageImpression(
          comboId, source, this.comboType, eventMergeId, this.variationId, this.daliComboAvailability)
      } else {
        submitMerge(this.buildInitialViewTracking());
        window.o_p13n_combopromo.tracking.sendPromoButtonPageImpressionTrackingEvent(
          comboId, source, this.comboType, window.o_p13n_combopromo.api.variationId, this.daliComboAvailability)
      }
    }
  }

  update(imageId) {
    if (!this.imageExists(imageId)) return;
    this.injectButtonHtml(imageId);
  }

  imageExists(imageId) {
    return this.imageIdToCombo && this.imageIdToCombo[imageId];
  }

  injectButtonHtml(imageId) {
    let comboLink = this.buildHrefLinkFor(imageId);
    let comboText = this.title;
    let comboTypeImageClass = this.cssComboTypeImageClass;
    let formatImageClass = this.cssFormatImageClass;
    let cssFormatButtonClass = this.cssFormatButtonClass;
    let imagePreset = this.comboType === "ROOM" ? "poi_room" : "poi_outfit";
    const imageUrl = `https:/*                                            */
    let comboId = this.imageIdToCombo[imageId].comboId;
    let source = this.imageIdToCombo[imageId].source;
    const dataToggles = this.toggles;

    this.destinationDomElement.innerHTML =
      this.generateComboPromoButtonHtml(cssFormatButtonClass, comboLink, comboId, source, imageUrl,
        comboTypeImageClass, formatImageClass, comboText, dataToggles);

    const comboButton = this.destinationDomElement.querySelector(`.${cssFormatButtonClass}`);
    if (comboButton) {
      comboButton.addEventListener('click', () => {
        window.o_p13n_combopromo.tracking.sendPromoButtonClickTrackingEvent(
          comboId, source, this.comboType, this.variationId, this.daliComboAvailability);
      });
    }
  }

  generateComboPromoButtonHtml(
    cssFormatButtonClass,
    comboLink,
    comboId,
    source,
    imageUrl,
    comboTypeImageClass,
    formatImageClass,
    comboText,
    dataToggles
  ) {
    return `<div class="combo_combopromo_button_wrapper" data-toggles='${dataToggles}'>
                    <oc-card-v2 oc-aria-label="${comboText}" size="50">
                        <a class="${cssFormatButtonClass}"
                            aria-label="${comboText}"
                            href="${comboLink}">
                            <picture>
                                <source srcset="${imageUrl + '&amp;fmt=auto'}">
                                <img class="${comboTypeImageClass}  ${formatImageClass}" 
                                     src="${imageUrl}" alt="" aria-hidden="true">
                             </picture>
                             <span class="combo_combopromo_button_text_wrapper">
                                 <span class="combo_combopromo_button_text oc-copy-125--m oc-m-50">${comboText}</span>
                             </span>
                         </a>
                    </oc-card-v2>
                </div>`.replace(/\n\s*/gm, "");
  }

  buildHrefLinkFor(imageId) {
    return `/k/${this.imageIdToCombo[imageId].comboId}?a=${this.articleNumber}`;
  }

  buildInitialViewTracking() {
    return {
      "promo_ComboType": this.comboType
    };
  }
}
